import apiFetch from '../apiFetch'

export default function (token, data, fleetId) {
  return apiFetch({ endPoint: `UnattendedProcess/SetOperateDataChargeFleet/${fleetId}`, method: 'POST', body: data, token: token })
}
